




































































import { Component, Prop, Vue } from 'vue-property-decorator';

import DestinationRouteCard from '~/components/cards/DestinationRouteCard.vue';

@Component({
  components: {
    DestinationMap: () => {
      if (process.client) {
        return import('~/components/maps/DestinationMap.vue');
      }
    },
    DestinationRouteCard,
  },
})
export default class DestinationRoutes extends Vue {
  @Prop(Object) destination: Types.DestinationItem;
  @Prop(Array) routes: Types.SportOption[];
  @Prop(Array) tracks: {difficulty: string, track: any, id: number}[];

  /* Skeleton length of fake cards to display based on user's window device */
  get skeletonLength () {
    if (process.client) {
      return window.innerWidth < 768 ? 1 : 4;
    }
    return 4;
  }

  /* The map will either have a special height before or after 768 px */
  get mapHeight () {
    if (process.client) {
      return window.innerWidth >= 768 ? '439px' : '239px';
    }
    return '439px';
  }

  /* If sport displayed contains spots, we will also display spot markers */
  get spotsMarkers () {
    const array: any = [];
    this.sportsToDisplay.map((s: any) => {
      if (s.type === 'SPOT') {
        s.routes.map((r: any) => {
          array.push([r.start?.latitude, r.start?.longitude]);
        });
      }
    });
    return array;
  }

  /* Based on filtered sports, we will display routes tracks if available */
  get tracksToFilter () {
    const arrayOfTracks: any = [];
    this.sportsToDisplay.map((s: any) => {
      s.routes.map((r: any) => {
        this.tracks.map((t: {difficulty: string, track: any, id: number}) => {
          if (r.id === t.id) {
            arrayOfTracks.push(t);
          }
        });
      });
    });
    return arrayOfTracks;
  }

  /*
    Will returns the sports filtered by the user, or all of them if none is
    selected.
  */
  get sportsToDisplay () {
    const array: any = [];
    /* eslint array-callback-return: 0 */
    const allFalsy: boolean = this.routes?.every((sport: any) => !sport.checked);
    if (allFalsy) return this.routes;

    this.routes.map((s: any) => {
      if (s.checked) {
        array.push(s);
      }
    });
    return array;
  }
}
